/** A token's free text: no bracket or line break, except a "[" that does not
 *  start another token. Stopping at the next token start keeps every scan
 *  linear (a plain `[^\]\r\n]*` re-read the rest of the line from each
 *  "[NEXT:"). Unrolled — a plain run, then "[" plus a plain run — so no regex
 *  engine keeps backtracking state per character. */
const TOKEN_BODY = String.raw`[^\[\]\r\n]*(?:\[(?!\s*(?:NEXT|POINT|POINTER)\s*:)[^\[\]\r\n]*)*`;
/** User [POINTER:], agent [POINT:] and agent [NEXT:] protocol text — the one
 *  display-token pattern for every surface (bubbles, chat, toasts, speech). */
const DISPLAY_TOKEN_RE = new RegExp(
  String.raw`(?:\[\s*(?:POINT|POINTER)\s*:\s*screen\s*=\s*\d+\s*,\s*x\s*=\s*-?\d+\s*,\s*y\s*=\s*-?\d+\s*\]|\[\s*NEXT\s*:${TOKEN_BODY}\])\s*`,
  "g",
);
/** A token still streaming in at the end of the text. */
const TRAILING_DISPLAY_TOKEN_RE = new RegExp(
  String.raw`\[\s*(?:POINT|POINTER|NEXT)(?:\s*:${TOKEN_BODY})?$`,
);

/** The display roster Denker prepends when a connected display is not attached
 *  to the prompt. Like the cursor token it is addressed to the runtime, not to
 *  the reader, so it must never reach a chat bubble or the activity log. */
const DISPLAY_ROSTER_RE = /\[\s*DISPLAYS\s*\][\s\S]*?\[\s*\/\s*DISPLAYS\s*\]\s*/g;
const TRAILING_DISPLAY_ROSTER_RE = /\[\s*DISPLAYS\s*\][\s\S]*$/;

export function stripCursorDisplayTokens(text: string): string {
  return text
    .replace(DISPLAY_ROSTER_RE, "")
    .replace(TRAILING_DISPLAY_ROSTER_RE, "")
    .replace(DISPLAY_TOKEN_RE, "")
    .replace(TRAILING_DISPLAY_TOKEN_RE, "")
    .trim();
}
